/**
 * RecommendationPill — Shared Component
 * Renders recommendation type as a VERDICT_PILL-styled pill.
 * Authority: ui-invariants.js VERDICT_PILL tokens
 */

import React from 'react';
import { VERDICT_PILL } from '@/config/ui-invariants';

const REC_TO_VERDICT = {
    save:   'strong',
    review: 'moderate',
    skip:   'weak',
};

const REC_LABELS = {
    save:   'Recommended \u2014 Save',
    review: 'Needs your review',
    skip:   'Recommended \u2014 Skip',
};

export function RecommendationPill({ type, className }) {
    const verdict = REC_TO_VERDICT[type] || 'moderate';
    const v = VERDICT_PILL[verdict] || VERDICT_PILL.moderate;
    const label = REC_LABELS[type] || REC_LABELS.review;

    return (
        <span
            className={className}
            style={{
                ...VERDICT_PILL.pill,
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
                background: v.background,
                color: v.text,
                border: `1px solid ${v.border}`,
            }}
        >
            <span style={{
                width: v.dotSize,
                height: v.dotSize,
                borderRadius: '50%',
                background: v.dot,
                flexShrink: 0,
            }} />
            {label}
        </span>
    );
}

export default RecommendationPill;
